import React from 'react';
import './LoadingData.css';

const LoadingData = () => (
  <div className="spinner"></div>
);

export default LoadingData;